<!-- @ts-nocheck -->
<template>
  <q-item v-if="isEnabled" v-bind="$attrs">
    <slot />
  </q-item>
  <div v-else variant="custom" v-bind="$attrs">
    <div class="p-2 font-normal leading-normal text-sm visible m-0 relative flex flex-no-wrap no-underline cursor-pointer outline-none
    hover:bg-gray-100 rounded-md transition-colors duration-200"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpItem");

defineOptions({
  name: "dtpItem",
  inheritAttrs: true
});
</script>
